import { useQuery, useMutation } from '@apollo/client';

import { GET_TREATMENT_FOR_IDENTIFIER_V2 } from './getTestTreatmentV2Query';
import { SET_ANONYMOUS_TO_USER } from './setAnnoymousIdToUserIdQuery';

export const useTestTreatmentV2 = (
  type,
  identifier,
  test,
  shouldSkip = false
) => {
  const { loading, data, error } = useQuery(GET_TREATMENT_FOR_IDENTIFIER_V2, {
    variables: {
      identifier,
      test,
      type,
    },
    skip: !identifier || shouldSkip,
  });

  return {
    testName: data?.getTreatment?.name,
    testTreatment: identifier ? data?.getTreatment?.treatment : 'control',
    loading,
    error,
  };
};

export const useAnonymousIdToUserId = () => {
  const [setAnonymousIdToUserId, { loading, data, error }] = useMutation(
    SET_ANONYMOUS_TO_USER
  );

  return {
    setAnonymousIdToUserId,
    count: data?.setAnonymousIdToUserId?.updatedTreatmentsCount,
    loading,
    error,
  };
};
